<script>import { tick } from "svelte";
import { closeModal } from "../../modal";
export let isOpen = false;
export let message = "";
export let title = "Error";
export let closeText = "Close";
export let onCloseCallback = () => {
};
function handleClose(ev) {
  ev.stopImmediatePropagation();
  onCloseCallback();
  closeModal();
}
function autofocus(el) {
  tick().then((v) => el.focus());
}
</script>

{#if isOpen}
  <dialog
    open={isOpen}
    on:scroll={ev => {
      ev.stopImmediatePropagation();
      ev.preventDefault();
    }}
  >
    <article class="card">
      <a href="#close" aria-label="Close" class="close" on:click={handleClose}> </a>
      <h3>{@html title}</h3>
      <p>{@html message}</p>
      <footer>
        <button type="button" class="secondary" on:click={handleClose} use:autofocus>{closeText}</button>
      </footer>
    </article>
  </dialog>
{/if}

<style>dialog {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /* z-index: var(--z1); */
}

article.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 40vw;
  min-height: 40vh;
}</style>
